import { Api } from '@/core/api.js'
const api = new Api()

const state = {
  person: {},
  personExists: false
}

const getters = {
  getPerson (state) {
    return state.person
  },

  getPersonExists (state) {
    return state.personExists
  }
}

const actions = {
  loadPlayer: ({ commit }, params) => {
    return api.get('player/' + params.person_id).then(function (response) {
      return commit('setPerson', response.data)
    })
  },

  addPlayer: ({ commit }, params) => {
    return api.post('player/add', params.input).then(function (response) {
      if (response.status) {
        commit('setPerson', response.data)
      }
      return response
    })
  },

  updatePlayer: ({ commit }, params) => {
    return api
      .post('player/' + params.person_id + '/update', params.input)
      .then(function (response) {
        return commit('setPerson', response.data)
      })
  },

  removePlayer: ({ commit }, params) => {
    return api
      .get('player/' + params.person_id + '/remove')
      .then(function (response) {
        return commit('setPerson', response.data)
      })
  },

  loadPerson: ({ commit }, params) => {
    return api.get('person/' + params.person_id).then(function (response) {
      return commit('setPerson', response.data)
    })
  },

  addPerson: ({ commit }, params) => {
    return api
      .post('person/add/' + params.type, params.input)
      .then(function (response) {
        if (response.status) {
          commit('setPerson', response.data)
        }

        return response
      })
  },

  updatePerson: ({ commit }, params) => {
    return api
      .post(
        'person/' + params.person_id + '/update/' + params.type,
        params.input
      )
      .then(function (response) {
        return commit('setPerson', response.data)
      })
  },

  removePerson: ({ commit }, params) => {
    return api
      .post('person/' + params.person_id + '/remove', params)
      .then(function (response) {
        return commit('setPerson', response.data)
      })
  },

  transferPerson: ({ commit }, params) => {
    const personId = params.person_id
    const teamId = params.team_id
    return api
      .post('player/' + personId + '/team-transfer/' + teamId, {})
      .then(function (response) {
        return response
      })
  },

  updateResponsables: ({ commit }, params) => {
    return api
      .post('player/' + params.person_id + '/update/responsable', params.input)
      .then(function (response) {
        return commit('setPerson', response.data)
      })
  },

  loadPersonCampus: ({ commit }, params) => {
    return api
      .get('campus/' + params.campus_id + '/player/' + params.participant_id)
      .then(function (response) {
        return commit('setPerson', response.data)
      })
  },

  campusUpdatePlayer: ({ commit }, params) => {
    return api
      .post(
        'campus/' +
          params.campus_id +
          '/player/' +
          params.participant_id +
          '/update',
        params.input
      )
      .then(function (response) {
        return commit('setPerson', response.data)
      })
  },

  campusUpdateInfoPlayer: ({ commit }, params) => {
    return api
      .post(
        'campus/' +
          params.campus_id +
          '/player/' +
          params.participant_id +
          '/update_info',
        params.input
      )
      .then(function (response) {
        return commit('setPerson', response.data)
      })
  },

  campusUpdateRooms: ({ commit }, params) => {
    return api
      .post(
        'campus/' +
          params.campus_id +
          '/player/' +
          params.participant_id +
          '/rooms',
        params.input
      )
      .then(function (response) {
        return commit('setPerson', response.data)
      })
  },

  campusUpdateTraining: ({ commit }, params) => {
    return api
      .post(
        'campus/' +
          params.campus_id +
          '/player/' +
          params.participant_id +
          '/training',
        params.input
      )
      .then(function (response) {
        return commit('setPerson', response.data)
      })
  },

  personValidteIfExists: ({ commit, rootState }, params) => {
    var event = rootState.current_event
    return api
      .post('person/validate_if_exists/' + event.id, params)
      .then(function (response) {
        return commit('setPersonExists', response.data)
      })
  },

  campusUpdateDocument: ({ commit }, params) => {
    return api
      .post('participant/update_document', params)
      .then(function (response) {
        return response
      })
  },

  loadPhotos: (context, params) => {
    return api
      .get(
        'campus/' +
          params.campus_id +
          '/player/' +
          params.participant_id +
          '/photos'
      )
      .then(function (response) {
        if (response.status) {
          return response.data
        } else {
          return []
        }
      })
  },

  sendImageRight: (context, params) => {
    const url = params.team_id
      ? 'sign/image-right/' +
        params.type +
        '/' +
        params.id +
        '/' +
        params.event_id +
        '/' +
        params.team_id +
        '/' +
        params.lang
      : 'sign/image-right/' +
        params.type +
        '/' +
        params.id +
        '/' +
        params.event_id +
        '/' +
        params.lang
    return api.get(url).then((response) => {
      if (!response.status) return false
      return true
    })
  },

  sendDocument: (context, params) => {
    const url =
      'sign/' +
      params.document +
      '/' +
      params.type +
      '/' +
      params.id +
      '/' +
      params.event_id +
      '/' +
      params.lang

    return api.get(url).then((response) => {
      if (!response.status) return false
      return true
    })
  },

  getLinkImageRight: (context, params) => {
    const url = params.team_id
      ? 'link/image-right/' +
        params.type +
        '/' +
        params.id +
        '/' +
        params.event_id +
        '/' +
        params.team_id +
        '/' +
        params.lang
      : 'link/image-right/' +
        params.type +
        '/' +
        params.id +
        '/' +
        params.event_id +
        '/' +
        params.lang
    return api.get(url).then((response) => {
      if (!response.status) return false
      return response.data
    })
  },

  getImageRightHtml: (context, params) => {
    let url =
      params.type +
      '/' +
      params.person_id +
      '/imagerights/' +
      params.event_id +
      '/' +
      params.language +
      '/' +
      params.token +
      '/print'

    return api.get(url).then((response) => {
      return response.data
    })
  },

  getMedicinesHtml: (context, params) => {
    let url =
      params.type +
      '/' +
      params.person_id +
      '/rest_documents/' +
      params.event_id +
      '/' +
      params.language +
      '/' +
      params.token +
      '/print'

    return api.get(url).then((response) => {
      return response.data
    })
  },

  signDocument: (context, params) => {
    let url =
      'sign/document/' +
      params.document +
      '/' +
      params.type +
      '/' +
      params.person_id +
      '/' +
      params.event_id
    return api.post(url, { check2: params.check2 }).then((response) => {
      return response.data
    })
  }
}

const mutations = {
  setPerson (state, value) {
    state.person = value
  },

  setPersonExists (state, value) {
    state.personExists = value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
